enum AdvancedSettingsType {
  FILTER_CONTROL_CHANGE_CLEARS_ALL_FILTERS = 'filter-control-change-clears-all-filters',
  LINK_CHANGE_CLEARS_ALL_FILTERS = 'link-change-clears-all-filters',
}

export default AdvancedSettingsType;
